import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from "@angular/router";
import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected readonly router: Router,
    protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): boolean | Observable<boolean> | Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      try {
        this.authenticated = await this.keycloakAngular.isLoggedIn();
        this.roles = await this.keycloakAngular.getUserRoles(true);

        const result = await this.checkAccessAllowed();
        resolve(result);
      } catch (error) {
        reject("An error happened during access validation. Details:" + error);
      }
    });
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    /*Force the user to log in if currently unauthenticated.*/
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.href.split("?")[0]
      });
    }

    /*Get the roles required from the route.*/
    const requiredRoles = route.data.roles;

    /*
     * Allow the user to to proceed if no additional roles
     * are required to access the route.
     */
    if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
      return true;
    }

    /*Allow the user to proceed if all the required roles are present.*/
    if (
      requiredRoles.filter((role) =>
        this.keycloak.getUserRoles().includes(role)
      ).length > 0
    ) {
      return true;
    } else {
      void this.router.navigateByUrl("smartfleet/public/unauthorized-user");
      return false;
    }
  }

  checkAccessAllowed(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      if (!this.authenticated) {
        this.keycloakAngular.login().catch((e) => console.error(e));
        return reject(false);
      } else {
        resolve(true);
      }
    });
  }
}
